import { AuthEnums } from "models/enums";
import { SalaryFormTypes } from "models/formTypes";
import useAPIClientHelper from "./useAPIClientHelper";
import { RequestConfig } from "wint-api-client/dist/baseClient";
import { WintSuperkollAPIModelWintSalaryEarlyPayout } from "wint-api-client/dist/types";

const toEarlyPayoutRequest = (
  formValues: SalaryFormTypes.EarlyPayout,
  yearMonth: number
): WintSuperkollAPIModelWintSalaryEarlyPayout.EarlyPayoutRequest => {
  return {
    personId: Number(formValues.employee?.id),
    yearMonth,
    payoutDate: formValues.payoutDate!,
    amount: formValues.payoutAmount!,
    amountType: formValues.amountType!,
    kind: formValues.payoutType!,
    useOneTimeTax: formValues.useOneTimeTax ?? false,
  };
};

function useEarlyPayoutService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getEarlyPayoutInfo = async (personExternalId: number, yearMonth?: number, config?: RequestConfig) => {
    const response = await apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).EarlyPayoutClient.GetEarlyPayoutInfo(personExternalId, yearMonth, config);
    return response.data;
  };

  const getPayouts = async (personExternalId: number, yearMonth: number, config?: RequestConfig) => {
    const response = await apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).EarlyPayoutClient.GetPayouts(personExternalId, yearMonth, config);
    return response.data;
  };

  const previewEarlyPayout = async (
    formValues: SalaryFormTypes.EarlyPayout,
    yearMonth: number,
    config?: RequestConfig
  ) => {
    const request = toEarlyPayoutRequest(formValues, yearMonth);
    const response = await apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).EarlyPayoutClient.PreviewEarlyPayout(request, config);
    return response.data;
  };

  const submitEarlyPayout = async (formValues: SalaryFormTypes.EarlyPayout, yearMonth: number) => {
    const request = toEarlyPayoutRequest(formValues, yearMonth);
    const response = await apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).EarlyPayoutClient.SubmitEarlyPayout(request);
    return response.data;
  };

  return {
    getEarlyPayoutInfo,
    getPayouts,
    previewEarlyPayout,
    submitEarlyPayout,
  };
}

export default useEarlyPayoutService;
